import { dispatch } from "hf-rt";
import { HOST_URL } from "../constants";
import { stringify } from "qs";
import { loading, chosenFilter } from "../models";
import writeCookie from "../function/writeCookie";
import getCookie from "../function/getCookie";
import deleteCookie from "../function/deleteCookie";

const initialState = {
  productRefinements: null,
  noSearchResult: false,
  searchProductList: [],
  activePage: 1,
  searchHistory: [],
  similarKeywords: []
};

let searchHistoryCookieArray = [];
// 商品標記位置
let scrollToMarker;
let clearMarker;

export default {
  name: "searchKeywords",
  actions: {
    fetchSearch: async function (keywords, data = null) {
      dispatch({ type: "FETCH_SEARCH" });
      let params;
      if (data) {
        // 搜尋頁行為
        params = data;
      } else {
        // 搜尋列行為
        params = {
          searchText: keywords,
          page: params.page || '1',
        };
      }
      const textParams = stringify(params);
      loading.actions.startLoadingBanner(true);
      this.showResultError(false);
      if (params.page === "1") {
        // 若商品在第一頁
        try {
          const response = await fetch(
            `${HOST_URL}/shopping/v1/catalogItemSearches/search?${textParams}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json"
              },
              credentials: "include"
            }
          );
          if (response.status === 200) {
            const data = await response.json();
            const searchProductList = data.productRefinements[0].productList;
            const activePage =
              data.productRefinements[0].productListPageInfo.page;
            // 載入新的資訊、商品
            this.updateSearchResult(
              data.productRefinements[0],
              searchProductList
            );
            // 顯示查無結果
            if (searchProductList.length > 0) {
              this.showResultError(false);
            } else {
              console.log("no result, keyword:" + textParams);
              this.showResultError(true);
            }
            // 更新頁面
            this.updatePage(activePage);
            // 搜尋成功儲存成歷史紀錄( 暫時不使用 )
            // this.updateSearchHistory(keywords);
            // 滾動至商品標記位置事件
            const marker = getCookie("product-marker");
            clearTimeout(scrollToMarker);
            clearTimeout(clearMarker);
            if (marker) {
              // 0.5秒後移動至上次停留的商品位置
              scrollToMarker = setTimeout(() => {
                console.log("scroll to:", marker);
                window.scrollTo({
                  top: parseInt(marker)
                });
              }, 500);
              // 1秒後消除商品停留位置的cookie
              clearMarker = setTimeout(() => {
                deleteCookie("product-marker");
              }, 1000);
            }
            // 將網址上的criteriaCode參數帶入FilterBar
            const { criteriaCode } = params;
            if (criteriaCode && criteriaCode !== "") {
              let array = [];
              const criteriaCodes = criteriaCode.split(",");
              const refinements = data.productRefinements[0].refinements;
              refinements.forEach(item => {
                item.criteria.forEach(option => {
                  criteriaCodes.forEach(crtier => {
                    if (crtier === option.code) {
                      array.push(option);
                    }
                  });
                });
              });
              array.forEach(item =>
                chosenFilter.actions.addFilterWithUrl(item)
              );
            }
            loading.actions.startLoadingBanner(false);
          } else {
            this.updateSearchResult(null, []);
            this.showResultError(true);
            loading.actions.startLoadingBanner(false);
            window.logApiErrors(
              "r",
              "fetchSearch",
              response.status,
              response.statusText
            );
            throw new Error("search error");
          }
        } catch (error) {
          console.log(error);
        } finally {
        }
      } else {
        // 若商品page不在第一頁
        const page1Params = { ...params, page: 1 };
        const textPage1Params = stringify(page1Params);
        // 先取得第一頁的商品資料
        try {
          const response = await fetch(
            `${HOST_URL}/shopping/v1/catalogItemSearches/search?${textPage1Params}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json"
              },
              credentials: "include"
            }
          );
          if (response.ok) {
            const data = await response.json();
            const searchProductList = data.productRefinements[0].productList;
            // 載入新的資訊、商品
            this.updateSearchResult(
              data.productRefinements[0],
              searchProductList
            );
            // 顯示查無結果
            if (searchProductList.length > 0) {
              this.showResultError(false);
            } else {
              console.log("no result, keyword:" + textParams);
              this.showResultError(true);
            }
            // let activeSortBy;
            // if (
            //   params.hasOwnProperty("sortBy") &&
            //   params.hasOwnProperty("sortDirection")
            // ) {
            //   activeSortBy = {
            //     sortBy: params.sortBy,
            //     sortDirection: params.sortDirection
            //   };
            // } else {
            //   activeSortBy = {
            //     sortBy: "",
            //     sortDirection: ""
            //   };
            // }
            let totalPageArray = [];
            for (var i = 0; i < params.page; i++) {
              totalPageArray.push(i);
            }
            try {
              // 依 page 順序循序發送 API，確保搜尋結果依照 API page response 排序
              for (let index = 0; index < totalPageArray.length; index++) {
                const pageIndex = totalPageArray[index];
                if (index !== 0) {
                  // 更新目前的頁數
                  this.updatePage(pageIndex + 1);
                  const moreParams = {
                    ...params,
                    page: pageIndex + 1
                  };
                  const response = await fetch(
                    `${HOST_URL}/shopping/v1/catalogItemSearches/search?${stringify(
                      moreParams
                    )}`,
                    {
                      method: "GET",
                      headers: {
                        "Content-Type": "application/json"
                      },
                      credentials: "include"
                    }
                  );
                  if (response.ok) {
                    const data = await response.json();
                    var products = data.productRefinements[0].productList;
                    const array = searchProductList;
                    for (var j = 0; j < products.length; j++) {
                      array.push(products[j]);
                    }
                    this.updateSearchResult(data.productRefinements[0], array);
                    // 滾動至商品標記位置事件
                    const marker = getCookie("product-marker");
                    clearTimeout(scrollToMarker);
                    clearTimeout(clearMarker);
                    if (marker) {
                      // 1秒後移動至上次停留的商品位置
                      scrollToMarker = setTimeout(() => {
                        loading.actions.startLoadingBanner(false);
                        // 200 為 LoadingBanner的高度
                        console.log("scroll to:", parseInt(marker));
                        window.scrollTo({
                          top: parseInt(marker)
                        });
                      }, 1000);
                      // 1.5秒後消除商品停留位置的cookie
                      clearMarker = setTimeout(() => {
                        deleteCookie("product-marker");
                      }, 1500);
                    } else {
                      loading.actions.startLoadingBanner(false);
                    }
                  } else {
                    window.logApiErrors(
                      "r",
                      "fetchSearch",
                      response.status,
                      response.statusText
                    );
                  }
                }
              }
            } catch (error) {
            } finally {
            }
            // 總共有幾頁
            // totalPageArray.map((data, index) => {
            //   if (index !== 0) {
            //     chosenFilter.actions.loadMoreProducts(
            //       keywords,
            //       data,
            //       activeSortBy,
            //       searchProductList
            //     );
            //   }
            // });
          } else {
            this.updateSearchResult(null, []);
            this.showResultError(true);
            window.logApiErrors(
              "r",
              "fetchSearch",
              response.status,
              response.statusText
            );
            throw new Error("search error");
          }
        } catch (error) {
        } finally {
        }
      }
    },
    updateSearchResult: function (data, searchProductList = []) {
      dispatch({ type: "UPDATE_SEARCH_RESULT", data, searchProductList });
    },
    showResultError: function (bool) {
      dispatch({ type: "SHOW_RESULT_ERROR", bool });
    },
    updatePage: function (page) {
      dispatch({ type: "UPDATE_PAGE", page });
    },
    updateSearchHistory: function (data) {
      const hasCookie = getCookie("searchHistory");
      if (hasCookie) {
        // 1.取得目前的Cookie
        const array = JSON.parse(hasCookie);
        // 2.使用目前的Cookie去push
        array.unshift(data);
        if (array.length > 5) {
          array.length = 5;
        }
        // 3.寫入Cookie紀錄
        const text = JSON.stringify(array);
        writeCookie("searchHistory", text);
        // 4.存入前端
        this.checkSearchHistoryInCookie();
      } else {
        // 沒有Cookie資料
        // 1.儲存在前端的空陣列
        searchHistoryCookieArray.unshift(data);
        // 2.轉字串
        const text = JSON.stringify(searchHistoryCookieArray);
        // 3.寫入Cookie紀錄
        writeCookie("searchHistory", text);
        // 4.存入前端
        dispatch({ type: "UPDATE_SEARCH_HISTORY", data });
      }
    },
    checkSearchHistoryInCookie: function () {
      const hasCookie = getCookie("searchHistory");
      if (hasCookie) {
        // 有Cookie資料，轉成JSON格式
        const data = JSON.parse(hasCookie);
        // 儲存到前端
        dispatch({ type: "CHECK_SEARCH_HISTORY_IN_COOKIE", data });
      } else {
        // 沒有Cookie資料
      }
    },
    fetchSimilarKeywords: async function (keywords) {
      try {
        const response = await fetch(
          `${HOST_URL}/shopping/v1/catalogItemSearches/autocomplete?searchText=${keywords}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json"
            },
            credentials: "include"
          }
        );
        if (response.ok) {
          const data = await response.json();
          dispatch({ type: "FETCH_SIMILAR_KEYWORDS", data });
        } else {
          const data = [];
          window.logApiErrors(
            "r",
            "fetchSimilarKeywords",
            response.status,
            response.statusText
          );
          dispatch({ type: "FETCH_SIMILAR_KEYWORDS", data });
        }
      } catch (error) {
        console.log(error);
      } finally {
      }
    }
  },
  reducers: function (state = initialState, action) {
    switch (action.type) {
      case "UPDATE_SEARCH_RESULT":
        return {
          ...state,
          productRefinements: action.data,
          searchProductList: action.searchProductList
        };
      case "SHOW_RESULT_ERROR":
        return {
          ...state,
          noSearchResult: action.bool
        };
      case "UPDATE_PAGE":
        return {
          ...state,
          activePage: action.page
        };
      case "UPDATE_SEARCH_HISTORY":
        return {
          ...state,
          searchHistory: [action.data, ...state.searchHistory]
        };
      case "CHECK_SEARCH_HISTORY_IN_COOKIE":
        return {
          ...state,
          searchHistory: action.data
        };
      case "FETCH_SIMILAR_KEYWORDS":
        return {
          ...state,
          similarKeywords: action.data
        };
      default:
        return state;
    }
  }
};
